module.exports = "/dist/assets/images/favicon-32x32.png";